export default __webpack_public_path__ + "static/media/lodgify_step3.094eaa5f.png";